/** @format */

import { Grid } from '@mui/material';
import ActivationCard from '../ActivationCard/ActivationCard';

function ActivationList({ activationList, handleActivation }) {
  return (
    <Grid container spacing={2}>
      {activationList.map((activation) => {
        return (
          <ActivationCard
            activation={activation}
            key={activation.activationId}
            handleActivation={handleActivation}
          />
        );
      })}
    </Grid>
  );
}

export default ActivationList;
